// import * as React from "react";
// import { Box, Paper, Typography, IconButton, Button } from "@mui/material";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
// import dayjs, { Dayjs } from "dayjs";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import { UseFormSetValue } from "react-hook-form";

// interface SlotAvailabilityCalendarProps {
//   setValue: UseFormSetValue<any>;
// }

// const SlotAvailabilityCalendar: React.FC<SlotAvailabilityCalendarProps> = ({
//   setValue,
// }) => {
//   const [selectedDates, setSelectedDates] = React.useState<Dayjs[]>([]);
//   const [currentMonth, setCurrentMonth] = React.useState(dayjs());

//  const toggleDate = (date: Dayjs) => {
//   setSelectedDates((prev) => {
//     const updated = prev.some((d) => d.isSame(date, "day"))
//       ? prev.filter((d) => !d.isSame(date, "day"))
//       : [...prev, date];

//     if (updated.length > 0) {
//       const sorted = [...updated].sort((a, b) => 
//         a.isAfter(b) ? 1 : -1
//       );
//       // Format like your LabSlot data: "2025-12-19T00:00:00"
//       const firstDate = sorted[0].toISOString().split('T')[0] + 'T00:00:00';
      
//       setValue("date", firstDate, { shouldDirty: true });
//       console.log("✅ Set date:", firstDate);
//     } else {
//       setValue("date", undefined, { shouldDirty: true });
//       console.log("❌ Cleared date");
//     }

//     return updated;
//   });
// };



//   const headerText = React.useMemo(() => {
//     if (selectedDates.length === 0) {
//       return "No date selected";
//     }

//     if (selectedDates.length === 1) {
//       return selectedDates[0].format("ddd, MMM DD");
//     }

//     const sorted = [...selectedDates].sort((a, b) =>
//       a.isAfter(b) ? 1 : -1
//     );

//     return `${sorted[0].format("ddd, MMM DD")} – ${sorted[
//       sorted.length - 1
//     ].format("ddd, MMM DD")}`;
//   }, [selectedDates]);

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 2.5,
//         borderRadius: "12px",
//         backgroundColor: "#F3FBF8",
//       }}
//     >
//       {/* Title */}
//       <Typography fontWeight={600} sx={{ mb: 0.5 }}>
//         Calendar – Slot Availability
//       </Typography>

//       {/* ✅ Selected Date Display */}
//       <Typography
//         variant="body2"
//         sx={{ mb: 2, color: "#098963", fontWeight: 600 }}
//       >
//         Selected Date(s): {headerText}
//       </Typography>

//       {/* Month Navigation */}
//       <Box
//         display="flex"
//         alignItems="center"
//         justifyContent="space-between"
//         mb={1}
//       >
//         <IconButton onClick={() => setCurrentMonth((m) => m.subtract(1, "month"))}>
//           <ChevronLeftIcon />
//         </IconButton>

//         <Typography fontWeight={600}>
//           {currentMonth.format("MMMM YYYY")}
//         </Typography>

//         <IconButton onClick={() => setCurrentMonth((m) => m.add(1, "month"))}>
//           <ChevronRightIcon />
//         </IconButton>
//       </Box>

//       {/* Calendar */}
//       <LocalizationProvider dateAdapter={AdapterDayjs}>
//         <DateCalendar
//           value={null}
//           referenceDate={currentMonth}
//           onChange={(date) => date && toggleDate(date)}
//           slots={{
//             day: (props) => {
//               const isSelected = selectedDates.some((d) =>
//                 d.isSame(props.day, "day")
//               );

//               return (
//                 <Box
//                   onClick={() => toggleDate(props.day)}
//                   sx={{
//                     width: 36,
//                     height: 36,
//                     borderRadius: "50%",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     cursor: "pointer",
//                     backgroundColor: isSelected ? "#098963" : "transparent",
//                     color: isSelected ? "#fff" : "#333",
//                     "&:hover": {
//                       backgroundColor: "#CDEBE2",
//                     },
//                   }}
//                 >
//                   {props.day.date()}
//                 </Box>
//               );
//             },
//           }}
//         />
//       </LocalizationProvider>

//       {/* Footer */}
//       <Box display="flex" justifyContent="flex-end" mt={2}>
//         <Button size="small" onClick={() => setSelectedDates([])}>
//           Clear
//         </Button>
//       </Box>
//     </Paper>
//   );
// };

// export default SlotAvailabilityCalendar;



import * as React from "react";
import { Box, Paper, Typography, IconButton, Button } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import dayjs, { Dayjs } from "dayjs";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { UseFormSetValue } from "react-hook-form";

interface SlotAvailabilityCalendarProps {
  setValue: UseFormSetValue<any>;
}

const SlotAvailabilityCalendar: React.FC<SlotAvailabilityCalendarProps> = ({
  setValue,
}) => {
  const [selectedDates, setSelectedDates] = React.useState<Dayjs[]>([]);
  const [currentMonth, setCurrentMonth] = React.useState(dayjs());

  const toggleDate = (date: Dayjs) => {
    setSelectedDates((prev) => {
      const updated = prev.some((d) => d.isSame(date, "day"))
        ? prev.filter((d) => !d.isSame(date, "day"))
        : [...prev, date];

      if (updated.length > 0) {
        const sorted = [...updated].sort((a, b) => 
          a.isAfter(b) ? 1 : -1
        );
        // 🔥 FIXED: Use local date only (YYYY-MM-DD) - no timezone conversion
        const firstDate = sorted[0].format("YYYY-MM-DD") + "T00:00:00";
        
        setValue("date", firstDate, { shouldDirty: true });
        console.log("✅ Set date:", firstDate, "Selected:", sorted[0].format("YYYY-MM-DD"));
      } else {
        setValue("date", undefined, { shouldDirty: true });
        console.log("❌ Cleared date");
      }

      return updated;
    });
  };

  const headerText = React.useMemo(() => {
    if (selectedDates.length === 0) {
      return "No date selected";
    }

    if (selectedDates.length === 1) {
      return selectedDates[0].format("ddd, MMM DD");
    }

    const sorted = [...selectedDates].sort((a, b) =>
      a.isAfter(b) ? 1 : -1
    );

    return `${sorted[0].format("ddd, MMM DD")} – ${sorted[
      sorted.length - 1
    ].format("ddd, MMM DD")}`;
  }, [selectedDates]);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: "12px",
        backgroundColor: "#F3FBF8",
      }}
    >
      {/* Title */}
      <Typography fontWeight={600} sx={{ mb: 0.5 }}>
        Calendar – Slot Availability
      </Typography>

      {/* ✅ Selected Date Display */}
      <Typography
        variant="body2"
        sx={{ mb: 2, color: "#098963", fontWeight: 600 }}
      >
        Selected Date(s): {headerText}
      </Typography>

      {/* Month Navigation */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <IconButton onClick={() => setCurrentMonth((m) => m.subtract(1, "month"))}>
          <ChevronLeftIcon />
        </IconButton>

        <Typography fontWeight={600}>
          {currentMonth.format("MMMM YYYY")}
        </Typography>

        <IconButton onClick={() => setCurrentMonth((m) => m.add(1, "month"))}>
          <ChevronRightIcon />
        </IconButton>
      </Box>

      {/* Calendar */}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateCalendar
          value={null}
          referenceDate={currentMonth}
          onChange={(date) => date && toggleDate(date)}
          slots={{
            day: (props) => {
              const isSelected = selectedDates.some((d) =>
                d.isSame(props.day, "day")
              );

              return (
                <Box
                  onClick={() => toggleDate(props.day)}
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    backgroundColor: isSelected ? "#098963" : "transparent",
                    color: isSelected ? "#fff" : "#333",
                    "&:hover": {
                      backgroundColor: "#CDEBE2",
                    },
                  }}
                >
                  {props.day.date()}
                </Box>
              );
            },
          }}
        />
      </LocalizationProvider>

      {/* Footer */}
      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Button size="small" onClick={() => setSelectedDates([])}>
          Clear
        </Button>
      </Box>
    </Paper>
  );
};

export default SlotAvailabilityCalendar;
